import { PerformanceStatusConfig, PerformanceStatusOption } from './types';

export enum PERFORMANCE_STATUS {
  EFFICIENT_ON_TRACK = 'efficientOnTrack',
  EFFICIENT_AT_RISK = 'efficientAtRisk',
  INEFFICIENT_ON_TRACK = 'inefficientOnTrack',
  INEFFICIENT_AT_RISK = 'inefficientAtRisk',
}

export const PERFORMANCE_STATUS_SNAKE_CASE_MAP = {
  starvationBidderApplied: 'starvation_bidder_applied',
  [PERFORMANCE_STATUS.EFFICIENT_ON_TRACK]: 'efficient_on_track',
  [PERFORMANCE_STATUS.EFFICIENT_AT_RISK]: 'efficient_at_risk',
  [PERFORMANCE_STATUS.INEFFICIENT_ON_TRACK]: 'inefficient_on_track',
  [PERFORMANCE_STATUS.INEFFICIENT_AT_RISK]: 'inefficient_at_risk',
};

export const PERFORMANCE_STATUS_CONFIG: Record<
  PerformanceStatusOption,
  PerformanceStatusConfig
> = {
  starvationBidderApplied: {
    dropdownLabel: 'Starvation Bidder Applied',
    starvation: null,
    spendForecast: null,
  },
  [PERFORMANCE_STATUS.EFFICIENT_ON_TRACK]: {
    dropdownLabel: 'Starvation: Success - Spend Forecast: On Track',
    starvation: { label: 'Success', intent: 'success' },
    spendForecast: { label: 'On Track', intent: 'success' },
  },
  [PERFORMANCE_STATUS.EFFICIENT_AT_RISK]: {
    dropdownLabel: 'Starvation: Success - Spend Forecast: At Risk',
    starvation: { label: 'Success', intent: 'success' },
    spendForecast: { label: 'At Risk', intent: 'error' },
  },
  [PERFORMANCE_STATUS.INEFFICIENT_ON_TRACK]: {
    dropdownLabel: 'Starvation: Fail - Spend Forecast: On Track',
    starvation: { label: 'Fail', intent: 'error' },
    spendForecast: { label: 'On Track', intent: 'success' },
  },
  [PERFORMANCE_STATUS.INEFFICIENT_AT_RISK]: {
    dropdownLabel: 'Starvation: Fail - Spend Forecast: At Risk',
    starvation: { label: 'Fail', intent: 'error' },
    spendForecast: { label: 'At Risk', intent: 'error' },
  },
} as const;
